/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { GetUserInfoResponse } from '../../models/get-user-info-response';

export interface GetUserInfo$Params {

/**
 * User email
 */
  email: string;
}

export function getUserInfo(http: HttpClient, rootUrl: string, params: GetUserInfo$Params, context?: HttpContext): Observable<StrictHttpResponse<GetUserInfoResponse>> {
  const rb = new RequestBuilder(rootUrl, getUserInfo.PATH, 'get');
  if (params) {
    rb.query('email', params.email, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<GetUserInfoResponse>;
    })
  );
}

getUserInfo.PATH = '/users/info';
